import { Plugin, AllSelection } from '@tiptap/pm/state';
import { Extension } from '@tiptap/react';

export const PreserveBlockTypeOnSelectAll = Extension.create({
  name: 'preserveBlockTypeOnSelectAll',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleTextInput(view, from, to, text) {
            const { state, dispatch } = view;

            // Only act when the entire document is selected (Ctrl+A)
            if (state.selection instanceof AllSelection) {
              const firstNode = state.doc.content.firstChild;
              const nodeType = firstNode?.type ?? state.schema.nodes.paragraph;
              const nodeAttrs = firstNode?.attrs ?? {};

              // Create a new node of the same type with the same attributes
              const newNode = nodeType.createAndFill(nodeAttrs) ?? state.schema.nodes.paragraph.createAndFill();

              if (!newNode) return false;

              // Replace the entire selection with the new node and insert the typed character
              const tr = state.tr.replaceSelectionWith(newNode).insertText(text);
              dispatch(tr);
              return true;
            }

            return false;
          }
        }
      })
    ];
  }
});
